import { logger } from '@/lib/logger';

// Lazy loader for PDF.js library
let pdfJsModule: any = null;
let loadingPromise: Promise<any> | null = null;

export async function loadPDFJS() {
  // Return cached module if already loaded
  if (pdfJsModule) {
    return pdfJsModule;
  }

  // Return existing promise if currently loading
  if (loadingPromise) {
    return loadingPromise;
  }

  // Start loading
  loadingPromise = (async () => {
    try {
      logger.log('Lazy loading PDF.js library...');

      // Dynamically import PDF.js
      const pdfjsLib = await import('pdfjs-dist');

      // Don't configure worker here - let pdfWorkerConfig.ts handle it
      // This ensures proper dev/prod handling and correct file extensions

      pdfJsModule = pdfjsLib;
      logger.log('PDF.js loaded successfully');
      return pdfjsLib;
    } catch (error) {
      logger.error('Failed to load PDF.js:', error);
      loadingPromise = null; // Reset on error so it can be retried
      throw error;
    }
  })();

  return loadingPromise;
}

// Export a function to check if PDF.js is loaded
export function isPDFJSLoaded() {
  return pdfJsModule !== null;
}

// Export a function to get PDF.js if already loaded (sync)
export function getPDFJSSync() {
  if (!pdfJsModule) {
    throw new Error('PDF.js not loaded yet. Call loadPDFJS() first.');
  }
  return pdfJsModule;
}
